var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("sheet-settings", {
        attrs: { sheet: _vm.sheet, "anonymous-mode": true },
        on: { addParticipants: _vm.openParticipantsModal }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modalNewParticipant",
          attrs: {
            title: "participants_add_modal_title",
            "modal-class": "modal-bookers",
            disabled: _vm.savingNewParticipants,
            applyDisabled: _vm.newParticipantInvalid
          },
          on: { apply: _vm.saveNewParticipant }
        },
        [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-danger": _vm.duplicateParticipant }
            },
            [
              _c("label", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: "participants_add_name_label",
                    expression: "'participants_add_name_label'"
                  }
                ],
                staticClass: "form-control-label"
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newParticipantName,
                    expression: "newParticipantName"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.newParticipantName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newParticipantName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.duplicateParticipant
                ? _c("div", {
                    directives: [
                      {
                        name: "i18n",
                        rawName: "v-i18n",
                        value: "participants_duplicateName",
                        expression: "'participants_duplicateName'"
                      }
                    ],
                    staticClass: "form-control-feedback"
                  })
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a96446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a96446","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/anonymous/settings.vue
// module id = ixKz
// module chunks = 3